import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './InputSelect.css';
import { fetchGet } from '../../cruds/remote';
import { params } from '../../cruds/restApi';
import debounce from 'debounce-promise';
import 'whatwg-fetch';
import getLabel from '../../translations/messages';
import PropTypes from 'prop-types';
import { classNames } from '../../functions/classNames';

class RemoteInputSelect extends Component {
  handleChange = v => {
    const selected = v ? v : { value: null };
    const value = this.props.multi ? selected.map(s => s.value) : selected.value;

    this.props.handleChange({
      target: {
        name: this.props.name,
        value: value,
      },
    });

  };

  getLabel = (data, localize, locale, optionLabelName) => {
    if (Array.isArray(optionLabelName)) {
      return optionLabelName.map(l => data[l]).join(' - ');

    }

    return localize ? getLabel(locale, localize + '.' + data[optionLabelName]) : data[optionLabelName];

  };

  loadOptions = input => {
    const { from, optionValueName, optionLabelName, localize, param, order } = this.props;
    const { locale } = this.context;

    const paramName = param ? param : 'fullSearch';

    return fetchGet(from + params({ [paramName]: input, order: order }))
              .then(json => {
                const opts = json.map(j => ({
                  value: j[optionValueName],
                  label: this.getLabel(j, localize, locale, optionLabelName),
                }));
                return { options: opts };
              });
  };

  render() {
    return (
      <div
        className={classNames('InputSelect', this.props.error ? 'hasError' : '')}
        style={this.props.style}
        name={this.props.name + '-component'}
      >
        <div className="inputLabel">
          <span>{getLabel(this.context.locale, this.props.label)}</span>
          {this.props.required ? <span className="required">*</span> : ''}
        </div>
        <Select.Async
          multi={this.props.multi}
          name={this.props.name}
          value={this.props.name === "contactFrequency" ? this.props.value.contactFrequency :
        	  		this.props.name === "exposureTime" ? this.props.value.exposureTime :
            	  		this.props.name === "revelationProcessTemperaturePre" ? this.props.value.revelationProcessTemperaturePre :
        	  			this.props.value}
          onChange={selected => this.handleChange(selected)}
          loadOptions={debounce(this.loadOptions, 300)}
          noResultsText={getLabel(this.context.locale, 'general.noResults')}
          placeholder={getLabel(this.context.locale, this.props.placeholder || 'general.valueChoosing')}
        />
      </div>
    );
  }

}

RemoteInputSelect.contextTypes = {
  locale: PropTypes.string,
};

export default RemoteInputSelect;



// WEBPACK FOOTER //
// ./src/main/components/input/RemoteInputSelect.js